export enum Alert {
  ALERT = 'alert',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}
